import ProductDetails from "../components/ProductDetails"

export default function Show() {
    return (
        <div>
            <h4>Product Details</h4>
            <ProductDetails />
        </div>
    )
}